<template>
  <div class="profile-block__links">
    <p v-for="menuItem in currentPageMenu" :key="menuItem.routeName">
      <router-link :to="{name: menuItem.routeName}">{{menuItem.linkText}}</router-link>
    </p>
  </div>
</template>

<script>
 export default {
   data: function () {
     return {
       menu: [
         {
           routeName: 'profile-edit',
           linkText: 'Редактировать личные данные',
         },
         {
           routeName: 'profile',
           linkText: 'Профиль',
         },
         {
           routeName: 'profile-change-password',
           linkText: 'Изменить пароль',
         },
       ]
     };
   },
   computed: {
     currentPageMenu() {
       const routeName = this.$route.name;
       return this.menu.filter(menuItem => menuItem.routeName !== routeName);
     }
   }
 }
</script>